import AlertCircleIcon from '@/icons/AlertCircleIcon.svg?react';
import CheckCircleIcon from '@/icons/CheckCircleIcon.svg?react';
import IncompleteCircleIcon from '@/icons/IncompleteCircleIcon.svg?react';
import ProgressStarIcon from '@/icons/ProgressStarIcon.svg?react';
import { RunSchema } from '@/types/schema';
import { isRunIncomplete } from '@/utils/get-run-incomplete-status';
import { cn } from '@/utils/tailwind';

export function RunStatusChip({
  run,
  size,
  showText = true,
  className,
  simple,
  successName,
}: {
  run: RunSchema;
  size: 'xs';
  showText?: boolean;
  className?: string;
  simple?: boolean;
  successName?: string;
}) {
  if (!run.status) return null;

  return (
    <StatusChip
      status={
        run.status === 'pending' && isRunIncomplete(run)
          ? 'incomplete'
          : run.status
      }
      size={size}
      showText={showText}
      className={className}
      simple={simple}
      displayName={(run.status === 'success' && successName) || undefined}
    />
  );
}

export function StatusChip({
  status,
  size,
  showText = true,
  className,
  repetitions,
  simple,
  displayName,
}: {
  status: 'success' | 'error' | 'pending' | 'incomplete' | 'interrupted';
  size: 'xs';
  showText?: boolean;
  className?: string;
  repetitions?: number;
  simple?: boolean;
  displayName?: string;
}) {
  const icon = simple ? null : status === 'success' ? (
    <CheckCircleIcon className="h-3 w-3" />
  ) : status === 'error' ? (
    <AlertCircleIcon className="h-3 w-3" />
  ) : status === 'pending' ? (
    <ProgressStarIcon className="h-3 w-3" />
  ) : status === 'incomplete' ? (
    <IncompleteCircleIcon className="h-3 w-3" />
  ) : status === 'interrupted' ? (
    <AlertCircleIcon className="h-3 w-3" />
  ) : null;

  if (repetitions === 0) {
    return null;
  }

  return (
    status && (
      <div
        className={cn(
          'inline-flex w-auto items-center gap-1 rounded-md border bg-background font-medium uppercase leading-none tracking-wide',
          {
            ['text-brand border-brand']: status === 'pending',
            ['border-error text-error']: status === 'error',
            ['border-success text-success']: status === 'success',
            ['border-warning text-warning']: status === 'incomplete',
            ['border-purple text-purple']: status === 'interrupted',
          },
          {
            'px-1.5 py-0.5 text-xs': size === 'xs',
          },
          simple && 'border-none',
          className
        )}
      >
        {icon}

        {showText && (displayName || status)}

        {repetitions != null && (
          <span className="ml-0.5 flex flex-col items-end justify-center rounded-sm bg-secondary px-[5px] text-secondary">
            {repetitions}
          </span>
        )}
      </div>
    )
  );
}
